import dashboard from './dashboard';
import charts from './charts';
import followers from './followers';
import users from './users';
import orders from './orders';
import app from './app';
import userDetails from './userDetails';

export default {
    charts,
    dashboard,
    followers,
    users,
    orders,
    app,
    userDetails,
};
